/* eslint no-undef:0 */
import _isString from 'lodash/isString';
import { pageNames } from './page-name-identifiers';
import { getFPTIPageId } from './page';

const maskRegEx = /(\d\d+|(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,}))/g; // eslint-disable-line
const maskPattern = '#########';

function getPageDetails(id) {
  return pageNames[id];
}

function dataMasking(data) {
  if (_isString(data)) {
    return data.replace(maskRegEx, maskPattern);
  }

  return data;
}

function trackLink(options) {
  const fpti = { };
 // set link name
  fpti.link = options.link;

  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;
  fpti.pglk = `${pageDetails.pageGroupName}|${options.link}`;
  fpti.pgln = `${pageDetails.pageName}|${options.link}`;

  if (options.srch) {
    fpti.srch = dataMasking(options.srch);
  }

  if (options.hpid) {
    fpti.hpid = options.hpid;
  }

  if (getFPTIPageId() !== 'articlePage') {
    fpti.hpid = '';
  }

  if (options.feedback) {
    fpti.hcar = options.feedback.hcar;
    fpti.hcaf = options.feedback.hcaf;
  } else {
    // Clear hcar and hcaf
    fpti.hcar = '';
    fpti.hcaf = '';
  }

  // clearing out error props in case they exist
  fpti.erpg = '';
  fpti.erfd = '';
  fpti.eccd = '';

  // setting component
  fpti.comp = 'smarthelpnodeweb';
  try {
    PAYPAL.analytics.Analytics.prototype.recordClick({ data: fpti });
  } catch (e) {
    // suppress error
  }
}

function trackPage(options) {
  // const fpti = {}; // Using global FPTI variable
  fpti.link = options.link;

  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;

  if (options.link) {
    fpti.pglk = `${pageDetails.pageGroupName}|${options.link}`;
    fpti.pgln = `${pageDetails.pageName}|${options.link}`;
  } else {
    fpti.pglk = '';
    fpti.pgln = '';
  }

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // setting component
  fpti.comp = 'smarthelpnodeweb';
  try {
    PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
  } catch (e) {
    // suppress error
  }
}

function trackError(options) {
  // const fpti = {};
  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;

  if (options.errorField) {
    fpti.erpg = pageDetails.pageName;
    fpti.erfd = options.errorField;
  }

  PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
}

module.exports = { trackError, dataMasking, trackLink, trackPage };
